import React, {useEffect, useState} from 'react'
import KrajRolne from './components/KrajRolne'
import {ToastContainer} from 'react-toastify'
import KrajTraka from './components/KrajTraka'
import {useNavigate, useParams} from 'react-router-dom'
import notifyToast from '../../../components/Toast/Toast'
import {mojeStavkeNaNalogu, pauzirajRadniNalog} from '../../../api/radniNalozi'
import {FmkNalogiStavkeModel} from '../../../models/FmkNaloziModel'
import KrajTable from './components/KrajTable'

const RadniNalogKraj = () => {
    const {id} = useParams()
    const [selectedComponent, setselectedComponent] = useState<number>(0)
    const [dataStavka, setDataStavka] = useState<FmkNalogiStavkeModel>()
    const [nalogData, setNalogData] = useState<FmkNalogiStavkeModel>()

    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        if (id) {
            setLoading(true)
            const params = {idNaloga: id}
            console.log(params, 'paramssss')
            mojeStavkeNaNalogu(params)
                .then((response) => {
                    console.log('API response:', response.data)
                    setDataStavka(response.data)
                    setNalogData(response.data[0])
                })
                .catch((error) => notifyToast(false, error.message))
                .finally(() => setLoading(false))
        }
    }, [id])

    const handlePauzaRadnogNaloga = async () => {
        try {
            setLoading(true) // Start loading
            const params = {idNaloga: id}
            pauzirajRadniNalog(params)
                .then((response) => {
                    notifyToast(true, response.message)
                    setTimeout(() => {
                        navigate(-1)
                    }, 3000)
                })
                .catch((error) => notifyToast(false, error.message))
                .finally(() => setLoading(false))
        } catch (error) {
            console.error('API call failed:', error)
        } finally {
            setLoading(false) // End loading
        }
    }

    const components = [
        {component: <></>},
        {
            // @ts-ignore
            component: <KrajRolne nalogaId={id} stavka={dataStavka} />,
        },
        {
            component: <KrajTraka nalogaId={id!} />,
        },
    ]

    return (
        <div className='container-xxl px-0'>
            <ToastContainer />

            {/* Header Card */}
            <div className='card shadow-sm mb-6'>
                <div className='card-body p-4 p-md-5'>
                    <div className='d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-4'>
                        <div className='flex-grow-1'>
                            <div className='d-flex align-items-center gap-3 flex-wrap'>
                                <h1 className='fw-bolder text-dark mb-0'>
                                    Radni nalog: <span className='text-primary'>{nalogData?.nalog?.BrojNaloga}</span>
                                </h1>

                                <span className='badge bg-light text-dark border'>
                  ID: <span className='fw-semibold'>{id}</span>
                </span>
                            </div>

                            <div className='text-muted mt-2'>
                                Završetak naloga — odaberite da li završavate <span className='fw-semibold'>rolnu</span> ili{' '}
                                <span className='fw-semibold'>traku</span>.
                            </div>
                        </div>

                        <div className='d-flex flex-column flex-sm-row align-items-stretch gap-3'>
                            <button
                                type='button'
                                className='btn btn-danger px-5 d-inline-flex align-items-center justify-content-center'
                                onClick={handlePauzaRadnogNaloga}
                                disabled={loading}
                            >
                                {!loading && (
                                    <>
                                        <i className='fas fa-pause me-2' />
                                        Pauziraj radni nalog
                                    </>
                                )}

                                {loading && (
                                    <span className='d-inline-flex align-items-center'>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2' />
                  </span>
                                )}
                            </button>
                        </div>
                    </div>

                    <div className='alert alert-danger mt-4 mb-0 d-flex align-items-start gap-3'>
                        <i className='fas fa-exclamation-triangle fs-4 mt-1' />
                        <div>
                            <div className='fw-bolder mb-1'>Važno</div>
                            <div className='mb-0'>
                                Ukoliko pauzirate radni nalog, potrebno je ponovo pokrenuti proizvodnju istog.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Selector Card */}
            <div className='card shadow-sm mb-6'>
                <div className='card-body p-4 p-md-5'>
                    <label className='d-flex align-items-center form-label mb-3'>
                        <span className='fw-bold text-dark'>Odaberi rolnu / traku</span>
                        <i className='fas fa-exclamation-circle ms-2 fs-7 text-muted' data-bs-toggle='tooltip' />
                    </label>

                    <div className='row g-3' data-kt-buttons='true'>
                        <div className='col-12 col-md-6'>
                            <input
                                type='radio'
                                className='btn-check'
                                name='accountTeamSize'
                                value='1-1'
                                id='kt_account_team_size_select_1'
                                onChange={() => setselectedComponent(1)}
                                checked={selectedComponent === 1}
                            />
                            <label
                                className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 text-start h-100'
                                htmlFor='kt_account_team_size_select_1'
                            >
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div>
                                        <div className='fw-bolder fs-3'>ROLNA</div>
                                        <div className='text-muted mt-1'>Završetak rolnе i unos potrebnih podataka</div>
                                    </div>
                                    <i className={`fas fa-circle-check fs-2 ${selectedComponent === 1 ? 'text-primary' : 'text-muted'}`} />
                                </div>
                            </label>
                        </div>

                        <div className='col-12 col-md-6'>
                            <input
                                type='radio'
                                className='btn-check'
                                name='accountTeamSize'
                                value='2-10'
                                id='kt_account_team_size_select_2'
                                onChange={() => setselectedComponent(2)}
                                checked={selectedComponent === 2}
                            />
                            <label
                                className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 text-start h-100'
                                htmlFor='kt_account_team_size_select_2'
                            >
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div>
                                        <div className='fw-bolder fs-3'>TRAKA</div>
                                        <div className='text-muted mt-1'>Završetak trake i unos potrebnih podataka</div>
                                    </div>
                                    <i className={`fas fa-circle-check fs-2 ${selectedComponent === 2 ? 'text-primary' : 'text-muted'}`} />
                                </div>
                            </label>
                        </div>
                    </div>

                    {selectedComponent === 0 && (
                        <div className='mt-4 alert alert-warning mb-0'>
                            <div className='fw-bolder mb-1'>Nije odabrano</div>
                            <div className='mb-0'>Odaberite “ROLNA” ili “TRAKA” da biste nastavili.</div>
                        </div>
                    )}
                </div>
            </div>

            {/* Content */}
            <div className='card shadow-sm'>
                <div className='card-body p-4 p-md-5'>
                    <div className='row g-5'>
                        <div className='col-12'>
                            {dataStavka && components[selectedComponent].component}
                        </div>

                        <div className='col-12'>
                            {dataStavka && <KrajTable data={dataStavka} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RadniNalogKraj
